var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "language-selector-form" }, [_c('el-form', _vm._b({ ref: "form", staticClass: "el-schema-form", attrs: { "model": _vm.model, "rules": _vm.rules } }, 'el-form', _vm.config, false), [_c('el-form-item', { attrs: { "prop": "language" } }, [_c('el-radio-group', { on: { "change": _vm.handleChange }, model: { value: _vm.model.language, callback: function callback($$v) {
        _vm.$set(_vm.model, "language", $$v);
      }, expression: "model.language" } }, _vm._l(_vm.languages, function (language, index) {
    return _c('div', { key: index }, [_c('el-radio', { attrs: { "label": language.value } }, [_c('icon-language', { attrs: { "code": language.value } })], 1), _vm._v(" "), _vm._t("tail", null, { "language": language })], 2);
  }), 0)], 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };